module.exports = __webpack_public_path__ + "static/media/gender-male.6aecd6e9.svg";